import { GoogleTagManagerSetting } from 'backend';
import { getGtmLoadScriptElementId } from '../models';
import { executeGtm } from './executeGtm';
import { initializeGtm } from './initializeGtm';

type handleGtmPayload = {
  settings: GoogleTagManagerSetting[];
};
export const handleGtm = ({ settings }: handleGtmPayload): void => {
  if (settings.length === 0) {
    return;
  }
  settings.forEach((setting) => {
    const scriptElementId = getGtmLoadScriptElementId(setting.containerId);
    const scriptElement = document.getElementById(scriptElementId);
    if (scriptElement) {
      executeGtm(setting);
      return;
    }
    initializeGtm(setting);
  });
};
